module.exports = __webpack_public_path__ + "static/alitus-logo-social-efa9ef2fc3f84ce2500fcff2bbba2a9b.png";